export type MemberMetaDataMstItemDetail = {
  id: number
  label: string
  displayOrder: number
}

export type MemberMetaDataMstItemGroup = {
  groupId: number
  groupName: string
  itemDetail: MemberMetaDataMstItemDetail[]
}

export type MemberMetaDataMst = {
  itemId: string
  displayName: string
  requiredFlg: number
  requiredMessage?: string
  sortOrder: number
  itemList: MemberMetaDataMstItemGroup[]
}

export type MemberMetaDataValue = {
  itemId: string
  value: string
}

export type MemberMetaData = {
  memberMetaDataHeader: string
  memberMetaDataMst: MemberMetaDataMst[]
  memberMetaDataList: MemberMetaDataValue[]
}

export type MemberMetaDataJSON = MemberMetaData

export class MemberMetaDataDTO implements MemberMetaData {
  memberMetaDataHeader: string
  memberMetaDataMst: MemberMetaDataMst[]
  memberMetaDataList: MemberMetaDataValue[]

  constructor(
    memberMetaDataHeader: string,
    memberMetaDataMst: MemberMetaDataMst[],
    memberMetaDataList: MemberMetaDataValue[],
  ) {
    this.memberMetaDataHeader = memberMetaDataHeader
    this.memberMetaDataMst = memberMetaDataMst
    this.memberMetaDataList = memberMetaDataList
  }

  static fromJSON(jsonObject: MemberMetaDataJSON): MemberMetaDataDTO {
    return new MemberMetaDataDTO(
      jsonObject.memberMetaDataHeader,
      jsonObject.memberMetaDataMst,
      jsonObject.memberMetaDataList,
    )
  }
}
